var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/pdp-ugc-banner.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/contentful/pdp-ugc-banner.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("genericUrl")) {
var t_4 = t_1.genericUrl;
} else {
cb(new Error("cannot import 'genericUrl'")); return;
}
context.setVariable("genericUrl", t_4);
if(t_1.hasOwnProperty("contentfulUrl")) {
var t_5 = t_1.contentfulUrl;
} else {
cb(new Error("cannot import 'contentfulUrl'")); return;
}
context.setVariable("contentfulUrl", t_5);
if((lineno = 2, colno = 8, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.ugc.0.isEngage",false]))) {
output += "\n\n    ";
output += "\n\n    <img class=\"c-ugc-pdp__banner\" src=\"";
output += runtime.suppressValue((lineno = 7, colno = 54, runtime.callWrap(t_5, "contentfulUrl", context, [(lineno = 7, colno = 59, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.ugc.0.config.pdpBanner"]))])), env.opts.autoescape);
output += "\" alt=\"";
output += runtime.suppressValue((lineno = 7, colno = 101, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["ugc_pdp_banner_alt_text"])), env.opts.autoescape);
output += "\" data-qa-ugc-banner/>\n\n    <p class=\"c-ugc-pdp__line-one\">";
output += runtime.suppressValue((lineno = 9, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["ugc-pdp-line-one",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core"),"params": [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productMeta")),"displayName")]})])), env.opts.autoescape);
output += "</p>\n\n    <p class=\"c-ugc-pdp__line-two\">";
output += runtime.suppressValue((lineno = 11, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["ugc-pdp-line-two",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "</p>\n\n";
;
}
else {
output += "\n\n    <a ";
output += runtime.suppressValue((lineno = 15, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","ugc click",(lineno = 15, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["ugc_gallery-link"]))])), env.opts.autoescape);
output += " href=\"";
output += runtime.suppressValue((lineno = 15, colno = 78, runtime.callWrap(t_4, "genericUrl", context, [(lineno = 15, colno = 80, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["ugc_gallery-link"])),runtime.contextOrFrameLookup(context, frame, "queryParams"),runtime.contextOrFrameLookup(context, frame, "core"),runtime.contextOrFrameLookup(context, frame, "absoluteURL")])), env.opts.autoescape);
output += "\" data-qa-ugc-banner>\n        <img src=\"";
output += runtime.suppressValue((lineno = 16, colno = 32, runtime.callWrap(t_5, "contentfulUrl", context, [(lineno = 16, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.ugc.0.config.pdpBanner"]))])), env.opts.autoescape);
output += "\" alt=\"";
output += runtime.suppressValue((lineno = 16, colno = 79, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["ugc_pdp_banner_alt_text"])), env.opts.autoescape);
output += "\" />\n    </a>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/pdp-ugc-banner.j2"] , dependencies)